<div class="app-menu w-64 shrink-0 fixed left-0 top-0 h-screen z-50 transform transition-transform bg-[hsl(0,0%,96%)] border-r border-gray-200"
     [ngClass]="{
       '-translate-x-full': !isMobileMenuOpen && isMobile,
       'translate-x-0': isMobileMenuOpen || !isMobile,
       'md:w-64': sidebarSize === 'lg' || sidebarSize === null,
       'md:w-20': sidebarSize === 'sm',
       'md:w-16': sidebarSize === 'sm-hover'
     }">
  <!-- LOGO -->
<div class="navbar-brand-box">
  <a routerLink="/" class="flex items-center gap-2">
    <img src="assets/images/logos/stockistly-mark.svg"
         alt="Stockistly Logo" 
         class="w-8 h-8">
    <span class="text-lg font-bold text-gray-900" 
          [class.hidden]="sidebarSize === 'sm' && isDesktop">Stockistly</span>
  </a>
</div>

  <div class="h-[calc(100vh-64px)] overflow-y-auto">
    <div class="px-3 py-3">
      <ul id="navbar-nav" class="navbar-nav space-y-1">

        <ng-container *ngFor="let item of menuItems">
          <!-- Section Title -->
          <li class="menu-title" *ngIf="item.isTitle">
            <span [class.hidden]="sidebarSize === 'sm' && isDesktop">{{ item.label }}</span>
          </li>

          <!-- Top-level item -->
          <li class="nav-item" *ngIf="!item.isTitle && !item.isLayout">
            <!-- Parent with children -->
            <a *ngIf="hasItems(item)"
               href="javascript:void(0);"
               class="nav-link"
               [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}"
               (click)="toggleItem($event)">
              <svg *ngIf="item.icon" xmlns="http://www.w3.org/2000/svg" [attr.data-lucide]="item.icon" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></svg>
              <span class="flex-1" [class.hidden]="sidebarSize === 'sm' && isDesktop">{{ item.label }}</span>
              <span *ngIf="item.badge && (item.badge.text != '0' || !item.badge.hideIfZero)"
                    class="badge"
                    [ngClass]="item.badge.variant"
                    [class.hidden]="sidebarSize === 'sm' && isDesktop">{{ item.badge.text }}</span>
            </a>

            <!-- Simple link -->
            <a *ngIf="!hasItems(item) && !item.externalUrl"
               [routerLink]="item.link"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{ exact: true }"
               
               class="nav-link"
               (click)="toggleParentItem($event)">
              <svg *ngIf="item.icon" xmlns="http://www.w3.org/2000/svg" [attr.data-lucide]="item.icon" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></svg>
              <span class="flex-1" [class.hidden]="sidebarSize === 'sm' && isDesktop">{{ item.label }}</span>
              <span *ngIf="item.badge && (item.badge.text != '0' || !item.badge.hideIfZero)"
                    class="badge"
                    [ngClass]="item.badge.variant"
                    [class.hidden]="sidebarSize === 'sm' && isDesktop">{{ item.badge.text }}</span>
            </a>

            <!-- External link -->
            <a *ngIf="!hasItems(item) && item.externalUrl"
               [href]="item.externalUrl"
               [attr.target]="item.openInNewTab ? '_blank' : null"
               [attr.rel]="item.openInNewTab ? 'noopener noreferrer' : null"
               class="nav-link"
               [class.active]="activeExternalMenuId === item.id"
               (click)="activateExternalItem($event, item)">
              <svg *ngIf="item.icon" xmlns="http://www.w3.org/2000/svg" [attr.data-lucide]="item.icon" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></svg>
              <span class="flex-1" [class.hidden]="sidebarSize === 'sm' && isDesktop">{{ item.label }}</span>
              <span *ngIf="item.badge && (item.badge.text != '0' || !item.badge.hideIfZero)"
                    class="badge"
                    [ngClass]="item.badge.variant"
                    [class.hidden]="sidebarSize === 'sm' && isDesktop">{{ item.badge.text }}</span>
            </a>

            <!-- Submenu -->
            <div class="menu-dropdown collapse" *ngIf="hasItems(item)">
              <ul class="space-y-1">
                <li *ngFor="let subitem of item.subItems">
                  <!-- Subitem simple link -->
                  <a *ngIf="!hasItems(subitem)"
                     [routerLink]="subitem.link"
                     routerLinkActive="active"
                     class="nav-link text-sm"
                     [attr.data-parent]="subitem.parentId"
                     (click)="updateActive($event)">
                    {{ subitem.label }}
                    <span *ngIf="subitem.badge && (subitem.badge.text != '0' || !subitem.badge.hideIfZero)"
                          class="badge ml-auto"
                          [ngClass]="subitem.badge.variant">{{ subitem.badge.text }}</span>
                  </a>

                  <!-- Subitem with children -->
                  <a *ngIf="hasItems(subitem)"
                     href="javascript:void(0);"
                     class="nav-link text-sm"
                     [attr.data-parent]="subitem.parentId"
                     (click)="toggleSubItem($event)">
                    {{ subitem.label }}
                    <span *ngIf="subitem.badge && (subitem.badge.text != '0' || !subitem.badge.hideIfZero)"
                          class="badge ml-auto"
                          [ngClass]="subitem.badge.variant">{{ subitem.badge.text }}</span>
                  </a>

                  <!-- Sub-submenu -->
                  <div class="menu-dropdown collapse sub-menu" *ngIf="hasItems(subitem)">
                    <ul class="space-y-1">
                      <li *ngFor="let subSubitem of subitem.subItems">
                        <a *ngIf="!hasItems(subSubitem)"
                           [routerLink]="subSubitem.link"
                           routerLinkActive="active"
                           class="nav-link text-sm"
                           [attr.data-parent]="subSubitem.parentId"
                           (click)="updateActive($event)">
                          {{ subSubitem.label }}
                        </a>

                        <a *ngIf="hasItems(subSubitem)"
                           href="javascript:void(0);"
                           class="nav-link text-sm"
                           [attr.data-parent]="subSubitem.parentId"
                           (click)="toggleExtraSubItem($event)">
                          {{ subSubitem.label }}
                          <span *ngIf="subSubitem.badge"
                                class="badge ml-auto"
                                [ngClass]="subSubitem.badge.variant">{{ subSubitem.badge.text }}</span>
                        </a>

                        <div class="menu-dropdown collapse extra-sub-menu" *ngIf="hasItems(subSubitem)">
                          <ul class="space-y-1">
                            <li *ngFor="let subSubitem1 of subSubitem.subItems">
                              <a [attr.data-parent]="subSubitem1.parentId"
                                 [routerLink]="subSubitem1.link"
                                 routerLinkActive="active"
                                 class="nav-link text-sm"
                                 (click)="updateActive($event)">
                                {{ subSubitem1.label }}
                              </a>
                            </li>
                          </ul>
                        </div>

                      </li>
                    </ul>
                  </div>

                </li>
              </ul>
            </div>

          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
<!-- Left Sidebar End -->
<!-- Vertical Overlay-->
<div class="vertical-overlay" (click)="SidebarHide()"></div>
